import React, { Fragment, useEffect } from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import { EMAIL_MANDATORY, PHONE_MANDATORY, POSTAL_CODE_MANDATORY, SHOW_ALLERGY_OPTIONS } from "../../../config/constant";
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { toBool } from "../../JS/utility";
import { scrollToTop } from "../../../JS/scrollToTop";
import Select from 'react-select';


const DynamicBookingForm = (props) => {
    const { t } = props

    let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const [extraData, setExtraData] = React.useState({});
    const [customSelectState, setCustomSelectState] = React.useState({});
    const [openAddress, setOpenAddress] = React.useState(true);
    const [isAddressMandatory, setIsAddressMandatory] = React.useState(false);


    const [email, setEmail] = React.useState(props.email);
    const [phone, setPhone] = React.useState(props.phone);
    const [birthDate, setBirthDate] = React.useState(props.birthDate);
    const [eta, setETA] = React.useState("");
    const [allergies, setAllergies] = React.useState("");
    const [otherAllergies, setOtherAllergies] = React.useState("");

    const [customETASelect, setCustomETASelect] = React.useState(false);
    const [etaTimeList, setETATimeList] = React.useState([]);
    const selectItemsRef = React.useRef(null);

    const selectDynamicFormETAItemsRef = React.useRef([]);
    const [DynamicFormETA, setDynamicFormEta] = React.useState([]);

    const [address, setAddress] = React.useState({
        addressLine1: "",
        addressLine2: "",
        state: "",
        city: "",
        postalCode: "",
        country: ""
    })

    const addressHandler = (e, property) => {

        let updtAdd;

        if (property) {

            if (e) {
                property == "country" ?
                    updtAdd = { ...address, [property]: e.value, ["state"]: "" } :
                    updtAdd = { ...address, [property]: e.value }
            } else {
                property == "country" ?
                    updtAdd = { ...address, [property]: "", ["state"]: "" } :
                    updtAdd = { ...address, [property]: "" }
            }
        } else {
            updtAdd = { ...address, [e.target.name]: e.target.value };
        }

        setAddress(updtAdd)
    }

    const formatEstimateCheckInTime = (time, timeFormat12hrs) => {

        if (!time) {
            return "";
        }

        const [hours, minutes] = time.split(":");

        if (timeFormat12hrs) {
            let period = "AM";
            let hour = parseInt(hours, 10);

            if (hour >= 12) {
                period = "PM";
                if (hour > 12) {
                    hour -= 12;
                }
            }

            return `${hour}:${minutes} ${period}`;
        } else {
            return `${hours}:${minutes}`;
        }
    }

    const generateTimeOptions = () => {
        const options = [];
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += 15) {
                const hourString = String(hours).padStart(2, '0');
                const minuteString = String(minutes).padStart(2, '0');
                const timeValue = `${hourString}:${minuteString}`;
                const formatedTimeValue = timeValue;
                options.push(formatedTimeValue);
            }
        }

        let minETAOptions = options.filter(time => time >= ( props.cardChecksData.minETA || "00:00"))
        setETATimeList(minETAOptions);
    };

    const getStateList = (id, arr) => {

        let stateList = [];

        for (let obj of arr) {
            if (id == obj.countryId) {
                stateList = obj.stateList
            }
        }

        return stateList;
    }

    const getAddressLabel = (property) => {

        let labelName = null;
    
        if(property == "country"){
            props.countryOptions.forEach(item => {
                if(item.countryId == address.country){
                    labelName = item.countryName
                }
            })
        }
      
        if (property == "state"){
            getStateList(address.country,props.countryOptions).forEach(item => {
            if(item.stateId == address.state){
                labelName = item.stateName
            }
            })
        }

        return labelName
      }


    const handleDynamicFormChange = (value, field, parentObjectFieldKey) => {

        if (parentObjectFieldKey) {
            setExtraData((prevExtraData) => {
                const keys = parentObjectFieldKey.split('_');
                let updatedParentObjectFieldKeys = { ...prevExtraData };
    
                let currentLevel = updatedParentObjectFieldKeys;
    
                // Traverse the nested object based on keys
                for (const key of keys) {
                    if (currentLevel[key] === undefined) {
                        currentLevel[key] = {};
                    }

                    if (key === keys[keys.length - 1]) {
                        // Update the field value at the last level
                        currentLevel[key][field] = value;
                    } else {
                        // Move to the next level
                        currentLevel = currentLevel[key];
                    }
                }
    
                return { ...prevExtraData, ...updatedParentObjectFieldKeys };
            });
        } else {
            setExtraData({
                ...extraData,
                [field]: value
            });
        }
    };

    const getDynamicFormComponent = (resp, id, parentObjectFieldKey) => {

        const getFieldValue = (fieldKey) => {
            if (parentObjectFieldKey) {
                const keys = parentObjectFieldKey.split('_');
                let currentLevel = extraData;
        
                for (const key of keys) {
                    if (currentLevel[key] === undefined) {
                        return undefined;
                    }
        
                    currentLevel = currentLevel[key];
                }
        
                return currentLevel[fieldKey];
            } else {
                return extraData[fieldKey];
            }
        };

        return resp.type == "address" ? (
            <div className={`form-row margin-bottom-1 booking2_address_cont drawer ${openAddress && "open"}`}>
                <div class="drawer-header" onClick={() => setOpenAddress(!openAddress)}>
                    <div class="drawer-icons" >
                        <span class="fa fa-chevron-up"></span>
                        <span class="fa fa-chevron-down"></span>
                    </div>
                    <label>{t('check_in.address')} {isAddressMandatory && <span style={{ color: "red" }}>*</span>}</label>
                </div>
                {openAddress && <>
                    <Select
                        className="basic-single"
                        value={{label: getAddressLabel("country") || t('check_in.select_country'), value: address.country }}
                        onChange = {(e) => addressHandler(e, "country")}
                        isSearchable={true}
                        isClearable={true}
                        name="country"
                        options={props.countryOptions.map(item => {
                        return {
                            value: item.countryId,
                            label: item.countryName
                        }
                        })}
                    />
                    { getStateList(address.country, props.countryOptions).length > 0 &&
                        <Select
                            className="basic-single address-state"
                            value={{label: getAddressLabel("state") || t('check_in.select_state'), value: address.state }}
                            onChange = {(e) => addressHandler(e, "state")}
                            isSearchable={true}
                            isClearable={true}
                            name="state"
                            options={ getStateList(address.country,props.countryOptions).map(item => {
                                return {
                                    value: item.stateId,
                                    label: item.stateName
                                }})
                            }
                        />
                    }
                    <input style={{ marginTop: '0.7rem' }} type="text" name="addressLine1" autoComplete='address-line1' value={address.addressLine1} onChange={(e) => addressHandler(e)} placeholder={t('check_in.street_name_no')} />
                    <input style={{ marginTop: '0.7rem', marginBottom: "1rem" }} type="text" name="addressLine2" autoComplete='address-line2' value={address.addressLine2} onChange={(e) => addressHandler(e)} placeholder={t('check_in.bldg/unit/room')} />
                    <input style={{ marginTop: '0.7rem' }} type="text" name="city" autoComplete='address-level2' value={address.city} onChange={(e) => addressHandler(e)} placeholder={t('check_in.city')} />
                    <input style={{ marginTop: '0.7rem', marginBottom: "1rem" }} name="postalCode" autoComplete='postal-code' value={address.postalCode} onChange={(e) => addressHandler(e)} placeholder={t('check_in.postal_code')} />
                </>}
            </div>

        ) : resp.type == "customSelect" && !resp.dependency ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <div class={`custom-select`} >
                    <div className="select-selected" onClick={() => setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] }))} >{getFieldValue(resp.fieldKey) ? getFieldValue(resp.fieldKey) : resp.placeholder}</div>
                    {customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] && <div className="select-items" >
                        {
                            resp.option && resp.option.map((opt, index) => {
                                return (
                                    <div onClick={(e) => { handleDynamicFormChange(opt.value, resp.fieldKey, parentObjectFieldKey); setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] })) }} key={index} > {opt.displayName} </div>
                                )
                            })
                        }
                    </div>}
                </div>
            </div>

        ) : resp.type == "customSelect" && extraData[resp.dependencyData.dependencyfieldKey] == resp.dependencyData.dependencyValue ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <div class={`custom-select`} >
                    <div className="select-selected" onClick={() => setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] }))} >{getFieldValue(resp.fieldKey) ? getFieldValue(resp.fieldKey) : resp.placeholder}</div>
                    {customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] && <div className="select-items" >
                        {
                            resp.option && resp.option.map((opt, index) => {
                                return (
                                    <div onClick={(e) => { handleDynamicFormChange(opt.value, resp.fieldKey, parentObjectFieldKey); setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] })) }} key={index} > {opt.displayName} </div>
                                )
                            })
                        }
                    </div>}
                </div>
            </div>

        ) : resp.type == "select" && !resp.dependency ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <select value={getFieldValue(resp.fieldKey)} onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }} placeholder={resp.placeholder} >
                    <option value="">{resp.placeholder}</option>
                    {resp.option.length > 0 &&
                        resp.option.map((opt, index) => {
                            return (
                                <option key={index} value={opt.value}>{opt.displayName}</option>
                            )
                        })}
                </select>
            </div>

        ) : resp.type == "select" && extraData[resp.dependencyData.dependencyfieldKey] == resp.dependencyData.dependencyValue ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <select value={getFieldValue(resp.fieldKey)} onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }} placeholder={resp.placeholder} >
                    <option value="">{resp.placeholder}</option>
                    {resp.option.length > 0 &&
                        resp.option.map((opt, index) => {
                            return (
                                <option key={index} value={opt.value}>{opt.displayName}</option>
                            )
                        })}
                </select>
            </div>

        ) : resp.type == "textarea" && !resp.dependency ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <textarea
                    type={resp.type}
                    value={getFieldValue(resp.fieldKey)}
                    autoComplete={resp.autoComplete || null}
                    max={+resp.max || null}
                    min={+resp.min || null}
                    onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }}
                    placeholder={resp.placeholder}
                    disabled={resp.disabled || resp.disabled == "true"} 
                />
            </div>

        ) : resp.type == "textarea" && extraData[resp.dependencyData.dependencyfieldKey] == resp.dependencyData.dependencyValue ? (

            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <textarea
                    type={resp.type}
                    value={getFieldValue(resp.fieldKey)}
                    autoComplete={resp.autoComplete || null}
                    max={+resp.max || null}
                    min={+resp.min || null}
                    onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }}
                    placeholder={resp.placeholder}
                    disabled={resp.disabled || resp.disabled == "true"} 
                />
            </div>

        ) : resp.type == "eta" ? (

            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <div class={`custom-select`} >
                    <div className="select-selected" onClick={() => { 
                        setDynamicFormEta((prevETA) => {const newETA = [...prevETA]; newETA[id] = getFieldValue(resp.fieldKey) || null; return newETA;});
                        setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] }))}}
                    >
                            {getFieldValue(resp.fieldKey) ? formatEstimateCheckInTime(getFieldValue(resp.fieldKey), toBool(props.timeFormat)) : resp.placeholder}
                    </div>
                    <div className="select-items" ref={(ref) => selectDynamicFormETAItemsRef.current[id] = ref} >
                        {customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] &&
                            etaTimeList.map((time, index) => {
                                return (
                                    <div onClick={(e) => { 
                                        handleDynamicFormChange(time, resp.fieldKey, parentObjectFieldKey);
                                        setCustomSelectState(customSelectState => ({ ...customSelectState, [parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey]: !customSelectState[parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey] })) }} key={index} 
                                    > 
                                        {formatEstimateCheckInTime(time, toBool(props.timeFormat))}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

        ) : resp.type == "nestedObject" ? (
            <div className={`nestedObject-heading ${parentObjectFieldKey || ""}`} key={id}>
                <div className="form-row">
                    <p className="sub-text" style={{ color: resp.textColor }}>{resp.fieldName}</p>
                </div>
                {
                    resp.nestedKeys.map((nestedResp, index) => {
                        return getDynamicFormComponent(nestedResp, id + index, parentObjectFieldKey ? parentObjectFieldKey + "_" + resp.fieldKey : resp.fieldKey)
                    })
                }
            </div>

        ) : resp.type == "noticeText" ? (
            <div className="form-row" key={id}>
                <p className="sub-text" style={{ color: resp.textColor }}>{resp.textInput}</p>
            </div>
        ) : !resp.dependency ? (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <input
                    type={resp.type}
                    value={getFieldValue(resp.fieldKey)}
                    autoComplete={resp.autoComplete || null}
                    max={+resp.max || null}
                    min={+resp.min || null}
                    onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }}
                    placeholder={resp.placeholder}
                    disabled={resp.disabled || resp.disabled == "true"} 
                />
            </div>

        ) : resp.dependency && extraData[resp.dependencyData.dependencyfieldKey] == resp.dependencyData.dependencyValue && (
            <div className="form-row" key={id}>
                <label className="form-label text-capitalize">{resp.fieldName} {resp.mandatory && <span style={{ color: "red" }}>*</span>}</label>
                <input
                    type={resp.type}
                    value={getFieldValue(resp.fieldKey)}
                    autoComplete={resp.autoComplete || null}
                    max={+resp.max || null}
                    min={+resp.min || null}
                    onChange={(e) => { handleDynamicFormChange(e.target.value, resp.fieldKey, parentObjectFieldKey) }}
                    placeholder={resp.placeholder}
                    disabled={resp.disabled || resp.disabled == "true"} 
                />
            </div>
        )
    }

    const checkNestedObject = (form, dataRef, parentObjectFieldKeyData) => {
        let nestedProceed = true;
    
        form.nestedKeys.forEach((nestedObjectFromData) => {
            if (nestedObjectFromData.type === "nestedObject") {
                nestedProceed = checkNestedObject(nestedObjectFromData, parentObjectFieldKeyData, parentObjectFieldKeyData[nestedObjectFromData.fieldKey]);
            }

            if (nestedObjectFromData.type === "address") {

                if(nestedObjectFromData.mandatory){
                    if(!address.postalCode || address.postalCode == ""){
                        props.popupOpenClose(true, `Please enter your postal code`);
                        nestedProceed = false;
                    }

                    if(!address.city || address.city == ""){
                        props.popupOpenClose(true, `Please enter your city`);
                        nestedProceed = false;
                    }

                    if(!address.addressLine1 || address.addressLine1 == ""){
                        props.popupOpenClose(true, `Please enter your address`);
                        nestedProceed = false;
                    }

                    if(getStateList(address.country, props.countryOptions).length > 0 && (!address.state || address.state == "")){
                        props.popupOpenClose(true, `Please enter your state`);
                        nestedProceed = false;
                    }

                    if(!address.country || address.country == ""){
                        props.popupOpenClose(true, `Please enter your country`);
                        nestedProceed = false;
                    }
                }

                dataRef.address = address; 
            }
    
            if (nestedObjectFromData.mandatory) {
                if (!parentObjectFieldKeyData[nestedObjectFromData.fieldKey] || parentObjectFieldKeyData[nestedObjectFromData.fieldKey] === null || parentObjectFieldKeyData[nestedObjectFromData.fieldKey] === "") {
                    props.popupOpenClose(true, `Please enter all mandatory details`);
                    nestedProceed = false;
                }
            }
    
            if (nestedProceed && nestedObjectFromData.type === "email") {
                if (!emailRegex.test(parentObjectFieldKeyData[nestedObjectFromData.fieldKey])) {
                    props.popupOpenClose(true, "Please enter a valid email");
                    nestedProceed = false;
                }
            }
        });

        return nestedProceed;
    };

    const handleDynamicFormSubmit = (e) => {
        e.preventDefault();

        let proceed = true;

        props.DynamicBookingFormRequestData[props.dynamicFormIndex].formData.forEach((formData) => {
            if (formData.type == "nestedObject") {
                let result = checkNestedObject(formData, extraData, extraData[formData.fieldKey]);
                if(!result) proceed = false;
            }

            if (formData.type == "address") {

                if(formData.mandatory){

                    if(!address.postalCode || address.postalCode == ""){
                        props.popupOpenClose(true, `Please enter your postal code`);
                        proceed = false;
                    }

                    if(!address.city || address.city == ""){
                        props.popupOpenClose(true, `Please enter your city`);
                        proceed = false;
                    }

                    if(!address.addressLine1 || address.addressLine1 == ""){
                        props.popupOpenClose(true, `Please enter your address`);
                        proceed = false;
                    }

                    if(getStateList(address.country, props.countryOptions).length > 0 && (!address.state || address.state == "")){
                        props.popupOpenClose(true, `Please enter your state`);
                        proceed = false;
                    }

                    if(!address.country || address.country == ""){
                        props.popupOpenClose(true, `Please enter your country`);
                        proceed = false;
                    }
                }

                extraData.address = address;
            }

            if (formData.mandatory) {
                if (!extraData[formData.fieldKey] || extraData[formData.fieldKey] == null || extraData[formData.fieldKey] == "") {
                    props.popupOpenClose(true, `Please enter your ${formData.fieldName}`);
                    proceed = false;
                }
            }

            if (proceed && formData.type == "email") {
                if (!emailRegex.test(extraData[formData.fieldKey])) {
                    props.popupOpenClose(true, "Please enter a valid email");
                    proceed = false;
                }
            }
        })

        if (proceed) {
            props.next(extraData)
        }

    };


    const handleFormSubmit = (e) => {
        e.preventDefault();


        if (PHONE_MANDATORY) {
            if (!phone || phone == undefined || phone == "") {
                props.popupOpenClose(true, "Please enter your mobile number");
                return;
            }

            if (typeof (+phone) !== "number") {
                props.popupOpenClose(true, "Please enter a valid mobile number");
                return;
            }
        }

        if (EMAIL_MANDATORY) {
            if (!email) {
                props.popupOpenClose(true, "Please enter your email");
                return;
            }

            if (!emailRegex.test(email)) {
                props.popupOpenClose(true, "Please enter a valid email");
                return;
            }
        }

        if (POSTAL_CODE_MANDATORY) {
            if (!address.postalCode) {
                props.popupOpenClose(true, "Please enter your postal code");
                return;
            }
        }

        if (props.preCheckInEnabled && !props.isPreCheckInDone) {
            if (!eta || eta == "") {
                props.popupOpenClose(true, "Please provide your Estimate time of arrival");
                return;
            }
        }

        const formDetails = {
            email: email,
            eta: eta,
            phone: phone,
            birthDate: birthDate,
            address: address,
            allergies: allergies,
            otherAllergies: otherAllergies
        }

        props.next(formDetails);
    }

    const handleDynamicFormETAScroll = () => {
        selectDynamicFormETAItemsRef.current.forEach((ref, index) => {
          if (ref && DynamicFormETA[index]) {
            const itemHeight = 48;
            const selectedItemIndex = etaTimeList.indexOf(DynamicFormETA[index]);
            ref.scrollTop = selectedItemIndex * itemHeight;
          }
        });
    };

    React.useEffect(() => {
        handleDynamicFormETAScroll();
    }, [customSelectState])

    const handleETAScroll = () => {
        if (selectItemsRef.current) {
            const itemHeight = 45;
            const selectedItemIndex = etaTimeList.indexOf(eta);
            selectItemsRef.current.scrollTop = selectedItemIndex * itemHeight;
        }
    };


    React.useEffect(() => {
        if (customETASelect) handleETAScroll();
    }, [customETASelect])


    const handleDynamicDataOnFirstLoad = (resp) => {

        const handleNestedObjectKeys = (response, parentObjectFieldKey, parentObjectFieldKeyDataRef) => {

            let nestedObjectData = {};

            response.nestedKeys.forEach((nestedResp) => {

                const currentFieldKey = parentObjectFieldKey ? parentObjectFieldKey + "_" + nestedResp.fieldKey : nestedResp.fieldKey;

                if (nestedResp.type === "nestedObject") {
                    let nestedNestedObjectData = handleNestedObjectKeys(nestedResp, currentFieldKey, parentObjectFieldKeyDataRef && parentObjectFieldKeyDataRef[nestedResp.fieldKey]);

                    nestedObjectData[response.fieldKey] = {
                        ...nestedObjectData[response.fieldKey],
                        ...nestedNestedObjectData
                    }
                    return;
                }

                if (nestedResp.type == "address") {
                    if (nestedResp.openAddressDefault == true || nestedResp.openAddressDefault == false) {
                        setOpenAddress(nestedResp.openAddressDefault);
                    }

                    if(nestedResp.mandatory == true || nestedResp.mandatory == false){
                        setIsAddressMandatory(nestedResp.mandatory);
                    }
                }

                if (nestedResp.type != "address" && nestedResp.fieldKey) {
                    if (nestedResp.type == "customSelect" || nestedResp.type == "eta") {
                        setCustomSelectState(customSelectState => ({ ...customSelectState, [currentFieldKey]: false }))
                    }

                    if (nestedResp.fieldKey.toLowerCase() == "name") {
                        nestedResp.value = props.firstName + " " + props.lastName
                    } else if (nestedResp.fieldKey.toLowerCase() == "firstname" || nestedResp.fieldKey.toLowerCase() == "first_name") {
                        nestedResp.value = props.firstName
                    } else if (nestedResp.fieldKey.toLowerCase() == "lastname" || nestedResp.fieldKey.toLowerCase() == "last_name") {
                        nestedResp.value = props.lastName
                    } else if (nestedResp.fieldKey.toLowerCase() == "email") {
                        nestedResp.value = props.email
                    } else if (nestedResp.fieldKey.toLowerCase() == "phone" || nestedResp.fieldKey.toLowerCase() == "phonenumber" || nestedResp.fieldKey.toLowerCase() == "phone_number" || nestedResp.fieldKey.toLowerCase() == "mobile_number") {
                        nestedResp.value = props.phone
                    } else if (nestedResp.fieldKey.toLowerCase() == "eta") {
                        nestedResp.value = props.eta
                    } else if (nestedResp.fieldKey.toLowerCase() == "birthdate") {
                        nestedResp.value = props.birthDate
                    } else if(nestedResp.fieldKey.toLowerCase() == "arrivaldate"){
                        nestedResp.value = props.arrivalDate.split("T")[0]
                    } else if(nestedResp.fieldKey.toLowerCase() == "departuredate"){
                        nestedResp.value = props.departureDate.split("T")[0]
                    }
                    
                    nestedObjectData[response.fieldKey] = {
                        ...nestedObjectData[response.fieldKey],
                        [nestedResp.fieldKey]: parentObjectFieldKeyDataRef ? parentObjectFieldKeyDataRef[nestedResp.fieldKey] : (nestedResp.value || "")
                    }

                }
            });

            return nestedObjectData;
        }

        if (resp.type === "nestedObject") {
            let nestedObjectData = handleNestedObjectKeys(resp, resp.fieldKey, props.extraData && props.extraData[resp.fieldKey]);

            setExtraData(extraData => ({...extraData,...nestedObjectData}));
            return;
        }

        if (resp.type == "address") {
            if (resp.openAddressDefault == true || resp.openAddressDefault == false) {
                setOpenAddress(resp.openAddressDefault);
            }

            if(resp.mandatory == true || resp.mandatory == false){
                setIsAddressMandatory(resp.mandatory);
            }
        }

        if (resp.type !== "address" && resp.fieldKey) {

            if (resp.type == "customSelect" || resp.type == "eta") {
                setCustomSelectState(customSelectState => ({ ...customSelectState, [resp.fieldKey]: false }))
            }

            if (resp.fieldKey.toLowerCase() == "name") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.firstName + " " + props.lastName || resp.value }))
            } else if (resp.fieldKey.toLowerCase() == "firstname" || resp.fieldKey.toLowerCase() == "first_name") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.firstName || resp.value }))
            } else if (resp.fieldKey.toLowerCase() == "lastname" || resp.fieldKey.toLowerCase() == "last_name") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.lastName || resp.value }))
            } else if (resp.fieldKey.toLowerCase() == "email") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.email || resp.value }))
            } else if (resp.fieldKey.toLowerCase() == "phone" || resp.fieldKey.toLowerCase() == "phonenumber" || resp.fieldKey.toLowerCase() == "phone_number" || resp.fieldKey.toLowerCase() == "mobile_number") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.phone || resp.value }))
            } else if (resp.fieldKey.toLowerCase() == "eta") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.eta || formatEstimateCheckInTime(props.checkInStartTime, false) || "" }))
            } else if (resp.fieldKey.toLowerCase() == "birthdate") {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.birthDate || resp.value || "" }))
            } else if(resp.fieldKey.toLowerCase() == "arrivaldate"){
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.arrivalDate || resp.value || "" }))
            } else if(resp.fieldKey.toLowerCase() == "departuredate"){
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.departureDate || resp.value || "" }))
            }
            else {
                setExtraData(extraData => ({ ...extraData, [resp.fieldKey]: props.extraData && props.extraData[resp.fieldKey] || resp.value || "" }))
            }
        }
    }


    React.useEffect(() => {
        console.log(extraData)
    },[extraData])

    React.useEffect(() => {
        scrollToTop();
        generateTimeOptions();
        if (props.address) setAddress({ ...address, ...props.address })
        setETA(formatEstimateCheckInTime(props.checkInStartTime, false));


        props.DynamicBookingFormRequestData.length > 0 && props.DynamicBookingFormRequestData[props.dynamicFormIndex] && props.DynamicBookingFormRequestData[props.dynamicFormIndex].formData.map((resp) => {
            handleDynamicDataOnFirstLoad(resp);
        });

    }, [props.DynamicBookingFormRequestData])

    useEffect(()=>{
        scrollToTop();
    },[])


    return (props.DynamicBookingFormRequestData.length > 0 && props.DynamicBookingFormRequestData[props.dynamicFormIndex]) ? (
        <Fragment>
            <form>
                <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    {props.DynamicBookingFormRequestData[props.dynamicFormIndex].formData.map((resp, index) => (
                        getDynamicFormComponent(resp, index)
                    ))}

                    <div className="form-controls">
                        <button className="primary w-100 all-caps" disabled={props.checkinGuestLoading} type={"button"} onClick={(e) => handleDynamicFormSubmit(e)}>{props.primaryButtonText || t(`check_in.next`)}</button>
                        <button className="secondary w-100 all-caps margin-top-1" type={"button"} onClick={() => props.goBack()}>{t('check_in.back')}</button>
                    </div>
                </div>
            </form>
        </Fragment>
    ) : (
        <Fragment>
            <form >
                <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                     <div className="form-row margin-bottom-1">
                        <label style={{ marginTop: '0.7rem' }} for="email">{t('check_in.home_email')} {EMAIL_MANDATORY && <span style={{ color: "red" }}>*</span>}</label>
                        <input name="email" id="email" type="email" inputMode='email' autoComplete='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    
                        <div class="form-row margin-bottom-1 col-2 booking_phone">
                            <label class="w-100" for="number">{t('check_in.phone_number')} {PHONE_MANDATORY && <span style={{ color: "red" }}>*</span>}</label>
                            {/* <input class="w-20 margin-right-1" type="tel" inputMode="numeric" maxLength={4} name="Country code" value={countryPhoneCode} onChange={(e) => setState({countryPhoneCode:e.target.value})} placeholder="+00" /> */}
                            <div className="additional-form phone-number">
                                <span className="phone-plus-symbol" >(+)</span>
                                <input id="number" type="tel" autoComplete='tel' maxLength={14} name="Mobile" value={phone ? (phone.startsWith('+') ? phone.substring(1) : phone) : ''} onChange={(e) => setPhone('+' + e.target.value.replace(/[^0-9]/g, ''))} placeholder="000000000000" />
                            </div>
                        </div>

                    {props.preCheckInEnabled && !props.isPreCheckInDone && <div className="form-row margin-bottom-1">
                        <label style={{ marginTop: '0.7rem' }} for="eta">{t('check_in.eta')} <span class="important-asterisk" style={{ color: "red" }}>*</span></label>
                        <div class={`custom-select`} >
                            <div className="select-selected" onClick={() => setCustomETASelect(!customETASelect)} >{eta ? formatEstimateCheckInTime(eta, toBool(props.timeFormat)) : ""}</div>
                            <div className="select-items" ref={selectItemsRef}>
                                {customETASelect &&
                                    etaTimeList.map((time, index) => {
                                        return (
                                            <div onClick={(e) => { setETA(time); setCustomETASelect(!customETASelect) }} key={index} > {formatEstimateCheckInTime(time, toBool(props.timeFormat))} </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>}

                 
                   
                    {SHOW_ALLERGY_OPTIONS && <div className="form-row margin-bottom-1">
                        <label>{t('check_in.guest_checkin')}Allergy</label>
                        <select style={{ marginTop: '0.7rem', background: 'none' }} id="allergyList"
                            name="Allergies"
                            value={allergies}
                            onChange={(e) => setAllergies(e.target.value)}
                        >
                            {props.allergyOptions.map((op, index) => {
                                return <option key={op} value={op}>{op}</option>
                            })}
                        </select>
                    </div>}
                    {/*Show textarea when "Other" is selected from dropdown */}
                    {allergies == 'Other' &&
                        <div className="form-row margin-bottom-1">
                            <label>{t('check_in.allergies_other')}</label>
                            <textarea style={{ marginTop: '0.7rem' }} rows="4" value={otherAllergies} onChange={(event) => setOtherAllergies(event.target.value)} placeholder={t('check_in.specify_allergy_type')}></textarea>
                        </div>
                    }





                       
<div className={`form-row margin-bottom-1 booking2_address_cont drawer ${openAddress && "open"}`}>
                        <div class="drawer-header" onClick={() => setOpenAddress(!openAddress)}>
                            <div class="drawer-icons" >
                                <span class="fa fa-chevron-up"></span>
                                <span class="fa fa-chevron-down"></span>
                            </div>
                            <label>{t('check_in.country')}</label>
                        </div>
                        {openAddress && <>
                            <Select
                                className="basic-single"
                                value={{label: getAddressLabel("country") || t('check_in.select_country'), value: address.country }}
                                onChange = {(e) => addressHandler(e, "country")}
                                isSearchable={true}
                                isClearable={true}
                                name="country"
                                options={props.countryOptions.map(item => {
                                return {
                                    value: item.countryId,
                                    label: item.countryName
                                }
                                })}
                            />
                            { getStateList(address.country, props.countryOptions).length > 0 &&<>

                              <label>{t('check_in.state')}</label>
                                <Select
                                    className="basic-single address-state"
                                    value={{label: getAddressLabel("state") || t('check_in.select_state'), value: address.state }}
                                    onChange = {(e) => addressHandler(e, "state")}
                                    isSearchable={true}
                                    isClearable={true}
                                    name="state"
                                    options={ getStateList(address.country,props.countryOptions).map(item => {
                                        return {
                                            value: item.stateId,
                                            label: item.stateName
                                        }})
                                    }
                                />
                                </>
                            }
                            <div class="form-row margin-bottom-1" style={{marginTop:"1.5rem"}}>

                             <label>{t('check_in.steetname')}</label>
                            <input style={{ marginTop: '0rem' }} type="text" name="addressLine1" autoComplete='address-line1' value={address.addressLine1} onChange={(e) => addressHandler(e)}   />
                            </div>

                            <div class="form-row margin-bottom-1" style={{marginTop:"1.5rem"}}>

                                <label>{t('check_in.building_name')}</label>
                                <input style={{ marginTop: '0.0rem' }} type="text" name="addressLine2" autoComplete='address-line2' value={address.addressLine2} onChange={(e) => addressHandler(e)}   />
                            </div>
                            

                            <div class="form-row margin-bottom-1" style={{marginTop:"1.5rem"}}>

                                    <label>{t('check_in.city')}</label>
                           
                                  <input style={{ marginTop: '0rem' }} type="text" name="city" autoComplete='address-level2' value={address.city} onChange={(e) => addressHandler(e)}   />
                           </div>
                           

                           <div class="form-row margin-bottom-1" style={{marginTop:"1.5rem"}}>

                                    <label>{t('check_in.postal_code')} {POSTAL_CODE_MANDATORY && <span style={{ color: "red" }}>*</span>}</label>
                                    <input style={{ marginTop: '0rem' }} name="postalCode" autoComplete='postal-code' value={address.postalCode} onChange={(e) => addressHandler(e)}  />
                           
                            </div>
                           
                            {/* <input type="text" name="country" value = {address.country} onChange = {(e) => addressHandler(e)} placeholder="Country"/> */}
                        </>}
                    </div>
                   
                    
                    <div className="form-controls">
                        <button className="primary w-100 all-caps " disabled={props.checkinGuestLoading} type={"button"} onClick={(e) => { handleFormSubmit(e) }}>{props.primaryButtonText || t(`check_in.next`)}</button>
                    </div>
                </div>
            </form>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        checkInAddress: state.store2.checkInAddress,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        countryOptions: state.store2.guestBooking.countryOptions,
        allergyOptions: state.store2.guestBooking.allergyOptions,
        cardChecksData: state.store2.cardChecksData,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
    }
}

export default connect(mapStateToProps, {
    setCheckInAddress,
    popupOpenClose
})(withTranslation('translations')(DynamicBookingForm));